import "pixi";
import "phaser";

import * as logging from "./logging";
import BootState from "./states/boot";
import CreditsState from "./states/credits";
import LevelState from "./states/level";
import TitleState from "./states/title";
import LevelSelectState from "./states/level_select";
import CongratulationsState from "./states/congrats";
import * as i18n from "./i18n";

class App extends Phaser.Game {
    constructor() {
        super(800, 600, Phaser.AUTO, "", undefined, false, true);

        this.state.add("boot", BootState);
        this.state.add("credits", CreditsState);
        this.state.add("level", LevelState);
        this.state.add("title", TitleState);
        this.state.add("level-select", LevelSelectState);
        this.state.add("congratulations", CongratulationsState);

        this.state.start("boot");
    }
}

window.addEventListener("DOMContentLoaded", function() {
    logging.initialize();

    let language = localStorage.getItem("language");
    if (!language && window.URLSearchParams) {
        const parser = new window.URLSearchParams(window.location.search);
        const lang = parser.get("lang");
        if (lang && i18n.supports(lang)) {
            language = lang;
            localStorage.setItem("language", lang);
        }
    }

    if (!language) language = "en";
    i18n.setLanguage(<i18n.Language>language);

    document.body.addEventListener("contextmenu", (e) => {
        e.preventDefault();
    });

    i18n.loadFonts().then(() => {
        (window as any).game = new App();
    });

});



// WEBPACK FOOTER //
// ./src/index.ts